module.exports = __webpack_public_path__ + "static/img/g-bg.f05b27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-eight/g-bg.png
// module id = 6d7D
// module chunks = 0